<template>
  <div>
    <div v-if="pageLoader"
         style="position: absolute; top: 0; right: 0; bottom: 0; left: 0; padding-top: 25%; background-color: rgba(255, 255, 255, 0.31);">
      <div class="text-xs-center">
        <v-progress-circular
            :size="70"
            :width="7"
            indeterminate
            color="#ff9233"
            class="text-xs-center my-5"
            large
        ></v-progress-circular>
      </div>
    </div>

    <v-container fluid grid-list-md class="padding_10">
      <v-expansion-panel>
        <v-expansion-panel-content>
          <template v-slot:header>
            <div>Filters</div>
          </template>
          <v-card style="display: flex; flex-wrap: wrap; padding: 0px 10px 0px 10px; align-content: center;
          align-items: center; background-color: white" class="index_header">
            <v-flex sm6 md3 lg3>
              <v-checkbox
                  label="Initiated"
                  :value="filters.Initiated"
                  row
                  v-model="filters.Initiated"
                  @change="filterInitiated($event)"
                  class="request_checkbox"
                  :color="'black'"
              ></v-checkbox>
            </v-flex>

            <v-flex sm6 md3 lg3>
              <v-checkbox
                  label="Success"
                  :value="filters.Success"
                  row
                  v-model="filters.Success"
                  @change="filterSuccess($event)"
                  class="request_checkbox"
                  :color="'black'"
              ></v-checkbox>
            </v-flex>
            <v-flex sm6 md3 lg3>
              <v-checkbox
                  label="Failed"
                  :value="filters.Failed"
                  row
                  v-model="filters.Failed"
                  @change="filterFailed($event)"
                  class="request_checkbox"
                  :color="'black'"
              ></v-checkbox>
            </v-flex>
            <v-flex sm6 md3 lg3>
              <v-checkbox
                  label="Cancelled"
                  :value="filters.Cancelled"
                  row
                  v-model="filters.Cancelled"
                  @change="filterCancelled($event)"
                  class="request_checkbox"
                  :color="'black'"
              ></v-checkbox>
            </v-flex>

            <v-flex style="display: flex; flex-wrap: wrap; justify-content: space-between; align-items: center;
            flex-direction: row;">
              <v-flex sm12 md5 lg5>
                <v-autocomplete
                    v-model="filters.user_id"
                    :items="user_mob_list"
                    chips solo
                    :loading="loaders.mob_loader"
                    label="Search by Name or Mobile number"
                    :item-text="getItemNameMob"
                    item-value="id"
                    :search-input.sync="search_name"
                ></v-autocomplete>
              </v-flex>

              <v-flex sm11 md5 lg5>
                <v-autocomplete
                    v-model="filters.email_id"
                    :items="emails"
                    :loading="loaders.emails"
                    chips solo
                    label="Search by Email Id"
                    item-text="email"
                    item-value="email"
                    :search-input.sync="search_email_id"
                ></v-autocomplete>
              </v-flex>
            </v-flex>
          </v-card>

        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-layout row wrap class="table_opacity_8" style="padding-top: 10px;">
        <v-flex xs12>
          <v-data-table
              :items="subscriptionList"
              item-key="id"
              class="elevation-1"
              :loading="loaders.transaction_list"
              loading-text="Loading... Please wait"
              no-results-text="Loading... Please wait"
              :headers="headers"
              v-model="selected"
              :total-items="total_items"
              :rows-per-page-items="[10, 20, 50, 100]">
            <!--            :pagination.sync="pagination"-->

            <template v-slot:items="props">
              <tr>
                <td>
                  {{ props.item.user.first_name }} {{ " " }} {{ props.item.user.last_name }}
                </td>

                <td v-if="props.item.start_date != null">
                  {{ props.item.start_date }}
                </td>
                <td v-else> {{ " - " }}</td>

                <td v-if="props.item.total_paid_amount != null">
                  {{ props.item.total_paid_amount }}
                </td>
                <td v-else> {{ " - " }}</td>

                <td v-if="props.item.status != null">
                  <v-chip v-if="props.item.status == 'success'" color="#C8E6C9" text-color="#1B5E20">{{
                      "Success"
                    }}
                  </v-chip>
                  <v-chip v-else-if="props.item.status == 'initiated'" color="#FFEDAA" text-color="#935E0D">
                    {{ "Initiated" }}
                  </v-chip>
                  <v-chip v-else-if="props.item.status == 'failed'" color="rgba(255, 82, 82, 0.24)"
                          text-color="#ff5252">{{ "Failed" }}
                  </v-chip>
                  <v-chip v-else-if="props.item.status == 'cancelled'" color="#d2b5a1" text-color="#794936">
                    {{ "Cancelled" }}
                  </v-chip>
                </td>
                <td v-else> {{ " - " }}</td>

                <td v-if="props.item.pg_status_code"> {{ props.item.pg_status_code }}</td>
                <td v-else> {{ " - " }}</td>

                <td v-if="props.item.pg_transaction_date"> {{
                    moment(props.item.pg_transaction_date).format('DD MMM YYYY HH:mm a')
                  }}
                </td>
                <td v-else> {{ " - " }}</td>


                <td>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on , attrs}">
                      <v-btn icon v-on="on"
                             v-bind="attrs" small
                             @click.prevent="getInvoice(props.item.invoice_path)"
                             v-if="(props.item.status == 'success' && props.item.invoice_path != null)">
                        <v-icon class="material-icons orange--text" color="#bbbbc6">cloud_download</v-icon>
                      </v-btn>
                      <v-btn icon v-else>
                        <v-icon class="black--text" disabled>cloud_download</v-icon>
                      </v-btn>
                    </template>
                    <span>Download Invoice</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on , attrs}">
                      <v-btn icon v-on="on"
                             v-bind="attrs" small
                             v-if="props.item.is_payment_verified == 0 && (props.item.status != 'success')"
                             @click.prevent="getSyncData(props.item.reference_no)">
                        <v-icon class="material-icons orange--text" color="#bbbbc6">sync</v-icon>
                      </v-btn>
                      <v-btn icon v-else>
                        <v-icon class="black--text" disabled>sync</v-icon>
                      </v-btn>
                    </template>
                    <span>Sync Transaction</span>
                  </v-tooltip>

                </td>

              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>


      <v-dialog v-model="syncDataDialog" persistent max-width="450" width="400">
        <v-card>
          <v-card-title class="headline grey lighten-2">Transaction Status</v-card-title>
          <v-card-text style="padding: 40px 20px;">Current transaction status from ICICI Bank portal :
            <b>{{ syncData.status }} </b></v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat @click="syncDataDialog = false">Close</v-btn>
            <v-btn color="green darken-1" flat @click="confirmSyncData()">Confirm DB Sync</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="confirmSyncDataDialog" persistent max-width="450" width="450">
        <v-card>
          <v-card-title class="headline grey lighten-2">Are you sure you want to sync with DB?</v-card-title>
          <v-card-text><sup><span style="color:red">**</span></sup>After sync
            with DB user will receive the notification
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat @click="confirmSyncDataDialog = false">Cancel</v-btn>
            <v-btn color="green darken-1" flat @click="syncDataWithDB(transactionRef_id)">Sync with DB</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar
          v-model="snackbar.display"
          :color="snackbar.color"
          :top="snackbar.top"
          :bottom="snackbar.bottom"
          :left="snackbar.left"
          :right="snackbar.right"
          :timeout="snackbar.timeout"
      >
        {{ snackbar.message }}
        <v-btn text dark @click="snackbar.display = false">
          <v-icon right color="white"> close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
// import { mapGetters } from "vuex";
export default {
  name: "Index",
  watch: {
    pagination: {
      handler() {
        this.getSubscriptionList()
      },
    },
    search_email_id: function (val) {
      if (val != null && val.length >= 3) {
        this.loaders.emails = true;
        this.sub_filter_email = 1;
        this.getEmailList();
      }
      if (val == null || val == undefined) {
        this.getSubscriptionList();
      }
    },
    search_name: function (val) {
      if (val != null && val.length >= 3) {
        this.loaders.mob_loader = true;
        this.sub_filter_mob = 1;
        this.getEmailList();
      }
      if (val == null || val == undefined) {
        this.getSubscriptionList();
      }
    },
    'filters.email_id': function (newVal) {
      if (!newVal) {
        this.filters.email_id = newVal;
        this.getSubscriptionList();
      } else if (newVal == null || newVal == undefined) {
        this.filters.email_id = '';
        this.getSubscriptionList();
      }
    },
    'filters.user_id': function (newVal) {
      if (!newVal) {
        this.filters.user_id = '';
        this.getSubscriptionList();
      } else if (newVal == null || newVal == undefined) {
        this.filters.user_id = newVal;
        this.getSubscriptionList();
      }
    },
  },
  methods: {
    getSubscriptionList() {
      this.subscriptionList = [];
      this.loaders.transaction_list = true;
      this.pagination.filters = Object.assign({}, this.filters);
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/get-transactions-web`, {
        params: this.pagination
      }).then((response) => {
        if (response.data.status == 1) {
          this.loaders.transaction_list = false;
          this.subscriptionList = response.data.data;
          this.total_items = response.data.data.total;
        } else if (response.data.status == 0) {
          this.loaders.transaction_list = false;
          this.snackbar.message = response.data.message;
          this.snackbar.display = true;
        }
      });
    },
    filterInitiated(value) {
      this.filters.Success = false;
      this.filters.Failed = false;
      this.filters.Initiated = value;
      this.filters.Cancelled = false;
      this.getSubscriptionList();
    },
    filterSuccess(value) {
      this.filters.Success = value;
      this.filters.Failed = false;
      this.filters.Initiated = false;
      this.filters.Cancelled = false;
      this.getSubscriptionList();
    },
    filterFailed(value) {
      this.filters.Success = false;
      this.filters.Failed = value;
      this.filters.Initiated = false;
      this.filters.Cancelled = false;
      this.getSubscriptionList();
    },
    filterCancelled(value) {
      this.filters.Success = false;
      this.filters.Failed = false;
      this.filters.Initiated = false;
      this.filters.Cancelled = value;
      this.getSubscriptionList();
    },
    getEmailList() {
      let flag = '';
      if (this.sub_filter_mob == 1) {
        flag = "mob";
      } else if (this.sub_filter_email == 1) {
        flag = 'email';
      }
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/get-user-list`,
              {params: {subscriptioncall: flag}, headers: this.$headers})
          .then((response) => {
            if (response.data.status == 1) {
              this.loaders.emails = false;
              this.loaders.mob_loader = false;
              this.emails = response.data.data;
              this.user_mob_list = response.data.data;
            }
          }).catch((error) => {
        this.snackbar.message = "Something went wrong!";
        this.snackbar.display = true;
      })
    },
    getItemNameMob(item) {
      var fname = '';
      var lname = '';
      var mobile = '---';
      if (item.last_name !== null) {
        lname = item.last_name;
      }
      if (item.first_name !== null) {
        fname = item.first_name;
      }
      if (item.mobile !== null) {
        mobile = item.mobile;
      }
      return `${fname} ${lname} (${mobile})`
    },
    getInvoice(path) {
      const fileUrl = `${process.env.VUE_APP_AZURE_STORAGE_URL}` +
          `${process.env.VUE_APP_AZURE_STORAGE_CONTAINER}` + '/' + path;
      axios({
        method: 'get',
        url: fileUrl,
        responseType: 'arraybuffer',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': ' GET, PUT, POST, DELETE, OPTIONS',
          'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token'
        },
      })
          .then(response => {

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'invoice.pdf') //or any other extension
            document.body.appendChild(link)
            link.click()

          }).catch(() => console.log('error occured'))

    },
    getSyncData(id) {
      this.startLoading();
      this.transactionRef_id = "";
      this.syncData = [];
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/get-sync-transaction-data`,
          {params: {transaction_id: id}}).then((response) => {
        if (response.data.status == 1) {
          this.stopLoading();
          this.syncData = response.data.data;
          this.syncData.status = response.data.response_status;
          this.transactionRef_id = id;
          this.syncDataDialog = true;
        } else if (response.data.status == 0) {
          this.stopLoading();
          this.snackbar.message = response.data.message;
          this.snackbar.display = true;
        }
      }).catch((error) => {
        console.warn(error);
        this.stopLoading();
        this.snackbar.message = "Something went wrong!";
        this.snackbar.display = true;
      })
    },
    confirmSyncData() {
      this.syncDataDialog = false;
      this.confirmSyncDataDialog = true;
    },
    syncDataWithDB(id) {
      this.startLoading();
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/sync-db-transaction-web`, {
        transaction_ref_id: id,
        transaction_status: this.syncData
      }).then((response) => {
        if (response.data.status == 1) {
          this.stopLoading();
          this.syncURL = response.data.URL;
          if (this.syncURL != "") {
            this.syncDataDialog = false;
            this.confirmSyncDataDialog = false;
            this.stopLoading();
            window.open(this.syncURL, '_blank');
          } else {
            this.stopLoading();
            this.syncDataDialog = false;
            this.confirmSyncDataDialog = false;
          }
        } else if (response.data.status == 0) {
          this.stopLoading();
          this.syncDataDialog = false;
          this.confirmSyncDataDialog = false;
          this.snackbar.message = response.data.message;
          this.snackbar.display = true;
        }
      }).catch((error) => {
        console.warn(error);
        this.syncDataDialog = false;
        this.confirmSyncDataDialog = false;
        this.stopLoading();
        this.snackbar.message = "Something went wrong!";
        this.snackbar.display = true;
      })
    }
  },
  data() {
    return {
      pageLoader: false,
      filters: {
        Initiated: false,
        Success: false,
        Failed: false,
        Cancelled: false,
        email_id: "",
        user_id: "",
      },
      selected: [],
      subscriptionList: [],
      pagination: {descending: true, rowsPerPage: 10},
      snackbar: {
        message: "",
        display: false,
        color: "black",
        top: true,
        right: true,
        bottom: false,
        left: false,
        timeout: 2000,
      },
      loaders: {
        transaction_list: false,
        emails: false,
        mob_loader: false,
      },
      headers: [
        {text: "User Name", value: "first_name", sorted: false},
        {text: "Plan", value: "", sorted: false},
        {text: "Amount", value: "", sorted: false},
        {text: "Status", value: "", sorted: false},
        {text: "Status Code", value: "", sorted: false},
        {text: "Transaction Date", value: "", sorted: false},
        {text: "Action", value: "action"},
      ],
      total_items: 0,
      statusList: [
        {text: "All", value: "all"},
        {text: "Success", value: "Success"},
        {text: "Failed", value: "Failed"},
        {text: "Initiated", value: "Initiated"},
        {text: "Cancelled", value: "Cancelled"}
      ],
      search_email_id: "",
      search_name: "",
      emails: [],
      user_mob_list: [],
      sub_filter_email: 0,
      sub_filter_mob: 0,
      syncData: [],
      syncDataDialog: false,
      confirmSyncDataDialog: false,
      transactionRef_id: "",
      syncURL: "",
    }
  },
  mounted() {
    this.getSubscriptionList();
  }
}
</script>

<style scoped>

</style>
